import {
  Selectors,
  TierInfo,
  UserTierTypes,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import RewardsSummaryModule from 'components/RewardsSummaryModule';
import React from 'react';

const ConnectedRewardsSummaryModule = ({
  tierCreditsOverride,
}: {
  /** DEV ONLY: override tier credits from the store for local testing */
  tierCreditsOverride?: number;
}) => {
  const currentTierLevel = useWidgetState(
    Selectors.userExtendedTierCodeSelector
  ) as UserTierTypes;
  const currentTierInfo = useWidgetState(
    Selectors.userCurrentTierInfoSelector
  ) as TierInfo;
  const nextTierInfo = useWidgetState(
    Selectors.userNextTierInfoSelector
  ) as TierInfo;
  const allTiers = useWidgetState(Selectors.trTierSelector) as TierInfo[];
  const rewardCredits = useWidgetState(
    Selectors.userRewardCreditSelector
  ) as number;
  const tierCreditsFromStore = useWidgetState(
    Selectors.userTierCreditSelector
  ) as number;
  const tierCredits =
    tierCreditsOverride !== undefined
      ? tierCreditsOverride
      : tierCreditsFromStore;
  const fullName = useWidgetState(Selectors.userFullNameSelector) as string;
  const accountId = useWidgetState(Selectors.userAccountIdSelector) as string;
  const asOfDate = useWidgetState(
    Selectors.rewardCreditAsOfDateSelector
  ) as string;
  const expirationDate = useWidgetState(
    Selectors.rewardCreditExpirationDateSelector
  ) as string;
  const lastEarnedDate = useWidgetState(
    Selectors.rewardCreditLastEarnedDateSelector
  ) as string;

  return (
    <RewardsSummaryModule
      rewardCredits={rewardCredits}
      fullName={fullName}
      accountId={accountId}
      tierCredits={tierCredits}
      currentLevel={currentTierLevel}
      nextTierInfo={nextTierInfo}
      allTiers={allTiers}
      currentTierInfo={currentTierInfo}
      asOfDate={asOfDate}
      expirationDate={expirationDate}
      lastEarnedDate={lastEarnedDate}
    />
  );
};

export default ConnectedRewardsSummaryModule;
